import { useQuery } from '@apollo/client'
import * as SearchCell from './SearchCell'
import { gql } from '@apollo/client'

// Re-export gql for use in SearchCell.js
export { gql }

const Cell = (props) => {
  const { QUERY, beforeQuery, Loading, Empty, Failure, Success } = SearchCell

  if (!QUERY) {
    return <SearchCell.default {...props} />
  }

  const queryOptions = beforeQuery ? beforeQuery(props) : { variables: props }
  const { data, loading, error } = useQuery(QUERY, {
    ...queryOptions,
    fetchPolicy: queryOptions.fetchPolicy || 'cache-first',
    skip: !props.query, // Skip query if no query string
  })

  if (loading) {
    return Loading ? <Loading /> : <div>Loading...</div>
  }

  if (error) {
    return Failure ? <Failure error={error} /> : <div>Error: {error.message}</div>
  }

  if (!data || Object.keys(data).length === 0) {
    return Empty ? <Empty query={props.query} /> : null
  }

  // Extract the first key from data (RedwoodJS pattern)
  const dataKey = Object.keys(data)[0]
  const cellData = data[dataKey]

  return <Success {...props} {...{ [dataKey]: cellData }} />
}

export default Cell

